var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColors(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16663 3.93473C1.27855 4.3675 0.666626 5.27895 0.666626 6.33332C0.666626 7.80608 1.86053 8.99999 3.33329 8.99999C4.80605 8.99999 5.99996 7.80608 5.99996 6.33332C5.99996 6.22043 5.99294 6.10919 5.97933 5.99999M5.16662 8.53844C5.59399 8.82972 6.11042 9 6.66662 9C8.13938 9 9.33329 7.80609 9.33329 6.33333C9.33329 5.18768 8.61084 4.21077 7.59666 3.83333M7.66662 3.66667C7.66662 5.13943 6.47272 6.33333 4.99996 6.33333C3.5272 6.33333 2.33329 5.13943 2.33329 3.66667C2.33329 2.19391 3.5272 1 4.99996 1C6.47272 1 7.66662 2.19391 7.66662 3.66667Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColors);
export default __webpack_public_path__ + "static/media/colors.0d754bcacebd4106ef732da2ff10a4f8.svg";
export { ForwardRef as ReactComponent };